import Vue, { VueConstructor } from 'vue';
import store from '@/store';

import 'hotcss/src/hotcss';
import i18n from './core/locale';

/* import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; */

import Vant from 'vant';
import 'vant/lib/index.css';

import './css/awesome.min.css';

import './css/transition.fade.css';
import './css/transition.move.css';
import './css/transition.ease.css';

import http, { env, setHref } from './core/http';
import * as coreRouter from './core/router';
import axiosIns, { request, setHandler, setHeader, setParam } from './core/axios';
import global from './core/global';
import mixin from './core/mixin';

import NumberPlug from './utils/number';
import { onVisibilityChange, isLink } from './utils/document';
import screenfull, { onFullChange } from './utils/screenfull';
import { format, flatten, parseDict } from './utils/common';
import { config } from '@vue/test-utils';

NumberPlug.install(); //在Number的原型上挂载a,b,c,d,mod,pow,sqrt,toFixed方法;

const commonFiles = require.context('@/common', true);

interface IConfig {
	handler(params: { code: number; msg?: string; data?: any }): any;
	lang?: string;
	global?: any;
	platform?: string;
	href?: string;
}
export default {
	install (Vue: VueConstructor, conf: IConfig) {
		Vue.prototype.$http = http;
		Vue.prototype.$env = env;
		Vue.prototype.$axios = axiosIns;
		Vue.prototype.$request = request;
		Vue.prototype.$request.setHeader = setHeader;
		Vue.prototype.$request.setParam = setParam;
		Vue.prototype.$request.setHandler = setHandler;
		Vue.prototype.$global = global;
		Vue.prototype.$format = format;
		Vue.prototype.$flatten = flatten;
		Vue.prototype.$parseDict = parseDict;

		Vue.mixin(mixin);

		(i18n as any).locale = conf.lang || 'zh-cn'; //设置初始语言;

		conf.handler && setHandler(conf.handler); //设置axios通用回调;

		setHref(conf.href || window.location.href); //设置api环境;

		for (let g in conf.global || {}) {
			global.set(g, conf.global[g]); //设置全局变量;
		}

		/* onVisibilityChange((bool: boolean) => {
			global.set('documentVisible', bool);
		});
		onFullChange((bool: boolean) => {
			global.set('documentFull', bool);
		}); */

		coreRouter.init(); //初始化路由守护;

		const getType = (obj: any) => Object.prototype.toString.call(obj);
		commonFiles.keys().forEach(key => {
			let fileExtension: string = String(key.match(/[^\.]+$/g)).toLocaleLowerCase();
			let filePath: Array<string> = key.match(/[^\/]+/g) as Array<string>;
			let fileName: string = String(filePath.slice(-1)).replace(/\.[^.]+$/, '');
			let fileDefault: any = commonFiles(key).default;
			switch (fileExtension) {
				case 'vue':
					Vue.component(fileName, fileDefault);
					break;
				case 'js':
				case 'ts':
					switch (getType(fileDefault)) {
						case '[object Function]':
							Vue.prototype['$' + fileName] = fileDefault;
							break;
						case '[object Object]':
							if (
								(fileDefault.bind && getType(fileDefault.bind) == '[object Function]') ||
								(fileDefault.inserted && getType(fileDefault.inserted) == '[object Function]') ||
								(fileDefault.update && getType(fileDefault.update) == '[object Function]') ||
								(fileDefault.componentUpdated &&
									getType(fileDefault.componentUpdated) == '[object Function]') ||
								(fileDefault.unbind && getType(fileDefault.unbind) == '[object Function]')
							) {
								Vue.directive(fileName, fileDefault);
							}
							break;
					}
					break;
			}
		});

		if (conf.platform && String(conf.platform).toLowerCase() == 'mobile') {
			console.log('ui: 使用移动端VantUI库, 启用Hotcss功能!');
			Vue.use(Vant);
		} else {
			console.log('使用PC端ElementUI库.');
			/* Vue.use(ElementUI, { i18n: (key: any, value: any) => i18n.t(key, value) }); */
		}
	},
};
